import {Operation} from "./Operation.js";
import {NUMBER} from "../../../../constants";


export class CountDistinct extends Operation {

    static displayName() {
        return "CountDistinct";
    }

    static isNumeric() {
        return false;
    }

    static isCategorical() {
        return true;
    }

    static handlesDate() {
        return true;
    }

    static typeOverride() {
        return NUMBER;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = new Set([newValue]);
        }
        this.currValue.add(newValue);
    }

    finish(globalAggregation) {
        /**
         * This method is called after all rows have been processed. It returns the count of distinct values.
         */
        return this.currValue ? this.currValue.size : 0;
    }
}

export default CountDistinct;
